
















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Pagination } from '@/components/types';

@Component({ inheritAttrs: false })
export default class AppTable extends Vue {
  @Prop({ type: Object, default: () => ({}) }) pagination!: Pagination;

  options: Pagination = {};

  @Watch('options', { deep: true })
  onOptionsChange(pagination: Pagination) {
    if (JSON.stringify(pagination) === JSON.stringify(this.pagination)) return;

    this.$emit('update:pagination', pagination);
  }

  @Watch('pagination', { immediate: true, deep: true })
  onPaginationChange(pagination: Pagination) {
    this.options = { ...pagination };
  }

  onCount(counter: number) {
    this.options.pageCount = counter;
  }
}
